module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item columns"
  }, [_c('div', {
    staticClass: "column is-5 left-col",
    on: {
      "click": function($event) {
        _vm.saveAndAdvance(_vm.saveAndAdvanceIndex)
      }
    }
  }, [_vm._v(_vm._s(_vm.title) + "\n    "), (_vm.allComplete) ? _c('span', {
    staticClass: "button is-small is-primary"
  }, [_vm._v("COMPLETED")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column right-col"
  }, [_c('span', {
    staticClass: "row"
  }, [_c('CircledCheckMarkCircleIcon', {
    staticClass: "completed--icon",
    attrs: {
      "checked": _vm.videoComplete
    }
  }), _vm._v(" "), _c('p', [_vm._v("Video")])], 1), _vm._v(" "), _c('span', {
    staticClass: "row"
  }, [_c('CircledCheckMarkCircleIcon', {
    staticClass: "completed--icon",
    attrs: {
      "checked": _vm.commentComplete
    }
  }), _vm._v(" "), _c('p', [_vm._v("Comments")])], 1), _vm._v(" "), (_vm.isCoaching) ? _c('span', {
    staticClass: "row"
  }, [_c('CircledCheckMarkCircleIcon', {
    staticClass: "completed--icon",
    attrs: {
      "checked": _vm.coachingComplete
    }
  }), _vm._v(" "), _c('p', [_vm._v("Coaching Conversation")])], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "row"
  }, [_c('CircledCheckMarkCircleIcon', {
    staticClass: "completed--icon",
    attrs: {
      "checked": _vm.reflectionComplete
    }
  }), _vm._v(" "), _c('p', [_vm._v("Reflection")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-06f70fcb"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExerciseDropdown.vue
// module id = 973
// module chunks = 0